"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Slider;
var _material = require("@mui/material");
var _react = _interopRequireDefault(require("react"));
function Slider(props) {
  var defaultValue = props.defaultValue,
    value = props.value,
    marks = props.marks,
    min = props.min,
    max = props.max,
    onChange = props.onChange,
    step = props.step,
    valueLabelDisplay = props.valueLabelDisplay;
  var theme = (0, _material.useTheme)();
  var sliderStyles = {
    '.MuiSlider-rail': {
      backgroundColor: theme.palette.TwClrBgBrandTertiary,
      height: theme.spacing(0.5)
    },
    '.MuiSlider-track': {
      display: 'none'
    },
    '.MuiSlider-mark': {
      backgroundColor: theme.palette.TwClrBgBrand,
      height: '8px',
      width: '8px',
      borderRadius: '4px'
    },
    '.MuiSlider-thumb': {
      backgroundColor: theme.palette.TwClrBgBrand,
      height: '16px',
      width: '16px',
      borderRadius: '8px'
    }
  };
  var handleChange = function handleChange(event, val) {
    if (!Array.isArray(val)) {
      onChange(val);
    }
  };
  return /*#__PURE__*/_react.default.createElement(_material.Slider, {
    "aria-label": "Slider",
    defaultValue: defaultValue,
    value: value,
    marks: marks,
    min: min,
    max: max,
    onChangeCommitted: handleChange,
    step: step !== null && step !== void 0 ? step : null,
    valueLabelDisplay: valueLabelDisplay,
    sx: sliderStyles
  });
}